import LayoutPage from '@component/LayoutPage';
import { createStaticPropsFetcher } from '@lib/fetch/getStaticProps';
import type { GetStaticProps, NextPage } from 'next';

const PageView: NextPage = () => <LayoutPage />;

export default PageView;

export const getStaticProps: GetStaticProps = createStaticPropsFetcher('home');
